import COMPONENT_MAP from '../Repository/Components.js';

const DataManagementDetailLocalesPopup=({popupCallBack,rowId,parent,userData,application})=>{
    const pageCallback=async(action,args)=>{
        popupCallBack(action,args);
    }

    const renderPageDetail=()=>{
        const Component=COMPONENT_MAP['PageDetail'];
        return Component?(
            <Component
                recordId={null}
                userData={userData}
                application={application}
                entityType={'Locales'}
                entityParams={['_lang='+application.globalData.lang]}
                file={'DataManagementDetailLocalesPopup.js'}
                titleLabel={application.getLocale("PageLocalesNew")}
                pageCallback={pageCallback}
                pageTabs={[]}
                isPopUp={true}
                openOnUpdate={true}
            />
        ):null; 
    };
    return (renderPageDetail());
}

export default DataManagementDetailLocalesPopup;
